import { JCEColorCodes } from 'chessboard/plugins/markings/model/convert-marking-from-jce';
import type { Markings } from 'chessboard/plugins/markings/config/types';
import { toStringArray } from 'utils/object/to-string-array';
import type JCE from '@chesscom/js-chess-engine';
import { KeyModifiers } from 'chessboard/model/dom/types';

/**
 * Convert to a JCE marking from a chessboard marking.
 */
export function convertMarkingToJCE(marking: Markings.KeyedModel): JCE.Marking.Model {
  const { data, persistent } = marking;

  const newData = { ...data };

  const jceColor = toJCEColor(data.keyPressed);

  if (persistent !== undefined) {
    newData.persistent = persistent;
  }

  if (jceColor !== JCEColorCodes.Custom) {
    delete newData.color;
  }

  // encode data
  Object.keys(newData).forEach((key) => {
    newData[key] = encodeURIComponent(newData[key]);
  });

  return {
    color: jceColor !== JCEColorCodes.Custom ? jceColor : undefined,
    data: toStringArray(newData),
    key: toJCEKey(marking),
    type: <JCE.Marking.Model['type']>marking.type,
  };
}

/**
 * Get a JCE key from a marking.
 */
function toJCEKey(marking: Markings.KeyedModel) {
  const {
    data: { from, square, to },
    key,
  } = marking;

  if (square) {
    return square;
  }

  if (from && to) {
    return `${from}${to}`;
  }

  return key;
}

/**
 * Convert to a JCE color from a chessboard color.
 */
function toJCEColor(color?: string) {
  switch (color) {
    case KeyModifiers.Alt:
      return JCEColorCodes.Alt;
    case KeyModifiers.None:
      return JCEColorCodes.Default;
    case KeyModifiers.Shift:
      return JCEColorCodes.Shift;
    case KeyModifiers.Ctrl:
      return JCEColorCodes.Ctrl;
    default:
      return JCEColorCodes.Custom;
  }
}
